import { QueryClientProvider } from "@tanstack/react-query";
import type { TypeWireContainer } from "@typewirets/core";
import { ContainerContext, ReactResolutionContext } from "@typewirets/react";
import * as React from "react";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClientWire } from "@/lib/query-client.wire";

interface AppProvidersProps {
  container: TypeWireContainer;
  children?: React.ReactNode;
}

export function AppProviders(props: AppProvidersProps) {
  const { container, children } = props;
  const reactContainer = React.useMemo(() => {
    if (container instanceof ReactResolutionContext) {
      return container;
    }

    return new ReactResolutionContext(container);
  }, [container]);

  const queryClient = QueryClientWire.getInstanceSync(container);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system" storageKey="ui-theme">
        <Toaster richColors closeButton toastOptions={{}} />
        <TooltipProvider delayDuration={500}>
          <ContainerContext.Provider value={reactContainer}>
            {children}
          </ContainerContext.Provider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
